import { Injectable } from '@angular/core';
import { DataService } from 'moh-package';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class GazzezetService {

  banksList: any[];
  bankBranchesList: any[];
  closenessList: any[];
  courtsList: any[];

  constructor(private dataService: DataService) { }

  getBanksList() {

    if (this.banksList) {
      return Observable.of(this.banksList)
    }
    return Observable.create(observer => {
      this.dataService.getList('MOH.Gazzezet.Bank').subscribe((res) => {
        this.banksList = res;
        observer.next(this.banksList);
      });
    });
  }

  getBankBranchesList() {

    if (this.bankBranchesList) {
      return Observable.of(this.bankBranchesList)
    }
    return Observable.create(observer => {
      this.dataService.getList('MOH.Gazzezet.BankBranch').subscribe((res) => {
        this.bankBranchesList = res;
        observer.next(this.bankBranchesList);
      });
    });
  }

  getClosenessList() {

    if (this.closenessList) {
      return Observable.of(this.closenessList)
    }
    return Observable.create(observer => {
      this.dataService.getList('MOH.Gazzezet.Closeness').subscribe((res) => {
        this.closenessList = res;
        observer.next(this.closenessList);
      });
    });
  }

  getCourtsList() {

    if (this.courtsList) {
      return Observable.of(this.courtsList)
    }
    return Observable.create(observer => {
      this.dataService.getList('MOH.Gazzezet.Court').subscribe((res) => {
        this.courtsList = res;
        observer.next(this.courtsList);
      });
    });
  }
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/services/general/gazzezet.service.ts